import { render, staticRenderFns } from "./RegulationsScope.vue?vue&type=template&id=7d036d94&scoped=true&"
import script from "./RegulationsScope.vue?vue&type=script&lang=js&"
export * from "./RegulationsScope.vue?vue&type=script&lang=js&"
import style0 from "./RegulationsScope.vue?vue&type=style&index=0&id=7d036d94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d036d94",
  null
  
)

export default component.exports